/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import axios from "axios";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../Context/MyProvider";
import Razorpay from "../PaymentMethod/Razorpay";
import Paypal from "../PaymentMethod/PayPal";
import { StripePayment } from "../PaymentMethod/Stripe";
import PayStack from "../PaymentMethod/PayStack";
import FlutterWave from "../PaymentMethod/FlutterWave";
import SenangPay from "../PaymentMethod/SenangPay";
import Payfast from "../PaymentMethod/Payfast";
import Midtrans from "../PaymentMethod/Midtrans";
import Checkout from "../PaymentMethod/Checkout";
import KhaltiPayment from "../PaymentMethod/Khalti_Payment";
import MercadoPagoCheckout from "../PaymentMethod/MercadoPago";
import PaytmPayment from "../PaymentMethod/PaytmPayment";
import Cashfree from "../PaymentMethod/Cashfree";
import SSLCommerz from "../PaymentMethod/SSLCommerz";
import Instamojo from "../PaymentMethod/Instamojo";
import Tap from "../PaymentMethod/Tap";
import PerfectMoney from "../PaymentMethod/PerfectMoney";
import PayDunya from "../PaymentMethod/PayDunya";
import Mollie from "../PaymentMethod/Mollie";
import BKash from "../PaymentMethod/bKash";
import { useTranslation } from "react-i18next";
import { MdOutlineErrorOutline } from "react-icons/md";
import { showTost } from "../showTost";
import wallet from "../Icon/wallet.svg";
import heartIcon from "../Icon/heartRed.svg";
import checkIcon from "../Icon/check.svg";
import lockIcon from "../Icon/unlock.svg";
import LodingLottie from "../Lodinglottie";

const cleanDateStr = (raw) => {
  if (!raw) return "";
  const str = String(raw).trim();
  return str.replace(/[T ]00:00(:00)?(\.000)?$/i, '');
};

const Upgrade = () => {
  const { t } = useTranslation();
  const {
    basUrl,
    imageBaseURL,
    planId,
    setPlanId,
    setTransactionId,
    setPageName,
    currency,
    setAmount,
    isIncognitoMasterEnabled = true,
    isPassportMasterEnabled = true,
    isSuperLikeMasterEnabled = true,
    isBoostMasterEnabled = true,
  } = useContext(MyContext);

  const getRegisterUser = () => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}");
    } catch {
      return {};
    }
  };

  const getCachedCoords = () => {
    try {
      const filterData = localStorage.getItem("FilterData");
      if (filterData) {
        const filter = JSON.parse(filterData);
        if (filter.lats && filter.longs) {
          return { lat: String(filter.lats), long: String(filter.longs) };
        }
      }
    } catch (e) {
      console.error("Error parsing FilterData:", e);
    }
    return { lat: "0", long: "0" };
  };

  const getInitialPackageId = () => {
    const userData = getRegisterUser();
    if (userData.plan_id > 0) return userData.plan_id;
    const purchaseId = localStorage.getItem("PurchaseId");
    if (purchaseId) return Number(purchaseId);
    return undefined;
  };

  const cachedCoords = getCachedCoords();
  const [latitude, setLatitude] = useState(cachedCoords.lat);
  const [longitude, setLongitude] = useState(cachedCoords.long);

  const [planLIst, setPlanList] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [payDetails, setPayDetails] = useState([]);
  const [border, setBorder] = useState();
  const [button, setButton] = useState(true);
  const [payId, setPayId] = useState();
  const [id, setId] = useState();
  const [pId, setPId] = useState();
  const [packageId, setPackageId] = useState(getInitialPackageId());
  const [planData, setPlanData] = useState([]);
  const [selectedPlanInfo, setSelectedPlanInfo] = useState(null);
  const [btnDis, setBtnDis] = useState(false);
  const [coin, setCoin] = useState();
  const [attributes, setAttributes] = useState();
  const [loading, setLoading] = useState(true);
  const hostedReturnProcessedRef = useRef(false);
  const legacyPaymentDoneProcessedRef = useRef(false);

  const currentPlanId = packageId ? String(packageId) : "0";
  const billingPeriodLabel = (plan) => {
    const period = plan?.billing_period || plan?.billingPeriod;
    const dayLimit = plan?.day_limit || plan?.dayLimit;
    if (period === "6_month") return "6 months";
    if (period === "yearly") return "year";
    if (period === "monthly") return "month";
    if (Number(dayLimit) === 30) return "month";
    return `${dayLimit || 0} days`;
  };
  const cleanPlanFeature = (value = "") =>
    String(value)
      .replace(/[\u2705\u2713\u2714\u2611\uD83D\uDD12\uD83D\uDD13]/g, "")
      .replace(/[\u{1F300}-\u{1FAFF}]/gu, "")
      .replace(/[\uFE0E\uFE0F]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  const isLockedPlanFeature = (value = "") => /[\uD83D\uDD12]/.test(String(value));
  const normalizeFeatureGroup = (value, label = "") => {
    const group = String(value || "").trim();
    if (["Upgrade your likes", "Enhance your experience", "Premium discovery", "Take control"].includes(group)) {
      return group;
    }
    return featureGroupTitle(label);
  };
  const planFeatureItems = (plan) => {
    if (Array.isArray(plan?.feature_groups) && plan.feature_groups.length) {
      return plan.feature_groups
        .map((item) => {
          const label = cleanPlanFeature(item?.label || item);
          if (!label || isLockedPlanFeature(item?.label || item)) return null;
          return {
            label,
            group: normalizeFeatureGroup(item?.group, label),
          };
        })
        .filter(Boolean);
    }
    if (Array.isArray(plan?.feature_list) && plan.feature_list.length) {
      return plan.feature_list
        .filter((line) => !isLockedPlanFeature(line))
        .map(cleanPlanFeature)
        .filter(Boolean)
        .map((label) => ({ label, group: normalizeFeatureGroup("", label) }));
    }
    if (plan?.feature_json) {
      try {
        const parsed = JSON.parse(plan.feature_json);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed
            .map((item) => {
              const rawLabel = typeof item === "string" ? item : item?.label;
              const label = cleanPlanFeature(rawLabel);
              if (!label || isLockedPlanFeature(rawLabel)) return null;
              return {
                label,
                group: normalizeFeatureGroup(typeof item === "string" ? "" : item?.group, label),
              };
            })
            .filter(Boolean);
        }
      } catch (error) {
        console.warn("Unable to parse plan feature_json:", error);
      }
    }
    return String(plan?.description || "")
      .split("\n")
      .filter((line) => !isLockedPlanFeature(line))
      .map(cleanPlanFeature)
      .filter(Boolean)
      .map((label) => ({ label, group: normalizeFeatureGroup("", label) }));
  };
  const planFeatures = (plan) => {
    return planFeatureItems(plan).map((item) => item.label);
  };
  const allPlanFeatures = (plans = []) => {
    const features = [];
    plans.forEach((plan) => {
      planFeatureItems(plan).forEach((feature) => {
        if (!features.some((item) => item.label.toLowerCase() === feature.label.toLowerCase())) {
          features.push(feature);
        }
      });
    });
    return features;
  };
  const featureGroupTitle = (feature = "") => {
    const value = feature.toLowerCase();
    if (value.includes("passport")) {
      return "Premium discovery";
    }
    if (
      value.includes("incognito") ||
      value.includes("control") ||
      value.includes("see you") ||
      value.includes("privacy")
    ) {
      return "Take control";
    }
    if (value.includes("like") || value.includes("match")) {
      return "Upgrade your likes";
    }
    if (
      value.includes("chat") ||
      value.includes("call") ||
      value.includes("boost") ||
      value.includes("super") ||
      value.includes("undo") ||
      value.includes("rewind")
    ) {
      return "Enhance your experience";
    }
    return "Premium discovery";
  };
  const groupedPlanFeatures = (features = []) => {
    const orderedGroups = {
      "Upgrade your likes": [],
      "Enhance your experience": [],
      "Premium discovery": [],
      "Take control": [],
    };
    features.forEach((feature) => {
      const labelLower = (feature.label || "").toLowerCase();
      if (!isSuperLikeMasterEnabled && (labelLower.includes("super like") || labelLower.includes("superlike"))) return;
      if (!isBoostMasterEnabled && labelLower.includes("boost")) return;
      if (!isIncognitoMasterEnabled && labelLower.includes("incognito")) return;
      if (!isPassportMasterEnabled && labelLower.includes("passport")) return;
      const title = normalizeFeatureGroup(feature.group, feature.label);
      if (!orderedGroups[title]) orderedGroups[title] = [];
      orderedGroups[title].push(feature);
    });
    return Object.fromEntries(
      Object.entries(orderedGroups).filter(([, groupFeatures]) => groupFeatures.length),
    );
  };
  const planIncludesFeature = (plan, feature) =>
    planFeatures(plan).some((item) => item.toLowerCase() === feature.toLowerCase());
  const planPalette = (plan) => {
    const title = String(plan?.title || "").toLowerCase();
    if (title.includes("gold")) {
      return { start: "#FFE9A8", end: "#D49B18", accent: "#B77900", text: "#2A220F" };
    }
    if (title.includes("platinum")) {
      return { start: "#F3F0FF", end: "#8A7BC8", accent: "#6F5EA8", text: "#171326" };
    }
    if (title.includes("silver")) {
      return { start: "#FFF1F7", end: "#F091B6", accent: "#DF5F91", text: "#29131E" };
    }
    return { start: "#B61DFF", end: "#6A10D8", accent: "rgba(152,14,255,255)", text: "#FFFFFF" };
  };
  const hexToRgba = (hex, opacity) => {
    const cleaned = String(hex || "").replace("#", "");
    if (cleaned.length !== 6) return `rgba(152,14,255,${opacity})`;
    const r = parseInt(cleaned.slice(0, 2), 16);
    const g = parseInt(cleaned.slice(2, 4), 16);
    const b = parseInt(cleaned.slice(4, 6), 16);
    return `rgba(${r},${g},${b},${opacity})`;
  };

  const toggleBottomSheet = useCallback((e) => {
    if (e === "PayMent") {
      setIsVisible(false);
      setBtnDis(false);
    } else {
      setIsVisible(true);
    }
  }, []);

  const PalanDetailsHandler = () => {
    setIsVisible2(!isVisible2);
  };

  const openPlanInfo = (plan) => {
    setSelectedPlanInfo(plan);
  };

  const closePlanInfo = () => {
    setSelectedPlanInfo(null);
  };

  const SectionCloseHandler = useCallback(() => {
    setPlanId("");
    toggleBottomSheet("PayMent");
    setBorder("");
    setPayId("");
    setButton(false);
    setId("");
    localStorage.removeItem("PaymentDone");
    localStorage.removeItem("Amount");
    localStorage.removeItem("Data");
  }, [setPlanId, toggleBottomSheet]);

  const fetchUserData = useCallback(async (
    latitudeVal = "0",
    longitudeVal = "0",
  ) => {
    const userData = getRegisterUser();
    if (userData.id) {
      try {
        const response = await axios.post(`${basUrl}home_data`, {
          uid: userData.id,
          lats: latitudeVal,
          longs: longitudeVal,
        });
        if (response.data.Result === "true") {
          setPlanData(response.data.plandata);
          setPackageId(response.data.plan_id);
        }
      } catch (error) {
        console.error("Error :", error);
      }
    }
  }, [basUrl]);

  const loadData = useCallback(async (latVal = latitude, longVal = longitude) => {
    setLoading(true);
    const userData = getRegisterUser();

    const paymentPromise = axios
      .post(`${basUrl}payment_gateway`)
      .then((res) => {
        setPayDetails(res.data.paymentdata || []);
      })
      .catch((err) => {
        console.error("Error fetching payment gateways:", err);
      });

    const coinPromise = userData.id
      ? axios
          .post(`${basUrl}wallet_report`, { uid: userData.id })
          .then((res) => {
            if (res.data.Result === "true") {
              setCoin(res.data.wallet);
            }
          })
          .catch((err) => {
            console.error("Error fetching coin report:", err);
          })
      : Promise.resolve();

    const planPromise = userData.id
      ? axios
          .post(`${basUrl}plan`, { uid: userData.id })
          .then((res) => {
            setPlanList(res.data.PlanData || []);
          })
          .catch((err) => {
            console.error("Error fetching plan list:", err);
          })
      : Promise.resolve();

    const userPromise = userData.id
      ? axios
          .post(`${basUrl}home_data`, {
            uid: userData.id,
            lats: latVal,
            longs: longVal,
          })
          .then((res) => {
            if (res.data.Result === "true") {
              setPlanData(res.data.plandata);
              setPackageId(res.data.plan_id);
            }
          })
          .catch((err) => {
            console.error("Error fetching home data:", err);
          })
      : Promise.resolve();

    await Promise.allSettled([
      paymentPromise,
      coinPromise,
      planPromise,
      userPromise,
    ]);
    setLoading(false);
  }, [basUrl, latitude, longitude]);

  const verifyHostedUpgradeReturn = useCallback((params, gatewayName) => {
    const userData = getRegisterUser();
    const storageKey = `${gatewayName}PendingPayment`;
    const pendingData = localStorage.getItem(storageKey);
    let pending = {};

    if (pendingData) {
      try {
        pending = JSON.parse(pendingData);
      } catch (err) {
        pending = {};
      }
    }

    if (pending.item_type && pending.item_type !== "plan") {
      return;
    }

    const orderId = params.get("order_id") || pending.order_id;
    const gatewayReference = gatewayName === "Stripe"
      ? params.get("stripe_session_id") || pending.gateway_order_id
      : gatewayName === "PayStack"
        ? params.get("reference") || params.get("trxref") || pending.gateway_order_id
      : gatewayName === "FlutterWave"
        ? params.get("tx_ref") || pending.gateway_order_id
        : gatewayName === "MercadoPago"
          ? params.get("preference_id") || pending.gateway_order_id
          : gatewayName === "Khalti"
            ? params.get("pidx") || pending.pidx || pending.gateway_order_id
          : gatewayName === "Instamojo"
            ? params.get("payment_request_id") || params.get("payment_request") || pending.payment_request_id || pending.gateway_order_id
          : params.get("order_id") || pending.gateway_order_id;
    const gatewayTransactionId = params.get("transaction_id");
    const mercadoPagoPaymentId = params.get("payment_id") || params.get("collection_id");
    const instamojoPaymentId = params.get("payment_id") || params.get("payment");
    const tapChargeId = params.get("tap_charge_id") || params.get("charge_id") || params.get("id") || pending.tap_charge_id;
    const paydunyaToken = params.get("token") || params.get("invoice_token") || pending.invoice_token;
    const molliePaymentId = params.get("id") || params.get("payment_id") || pending.mollie_payment_id;
    const bkashPaymentId = params.get("paymentID") || params.get("payment_id") || pending.bkash_payment_id;

    if (!userData.id || !orderId || !gatewayReference) {
      showTost({ title: `${gatewayName} order details missing. Please retry payment.` });
      return;
    }

    axios.post(`${basUrl}verify_payment`, {
      uid: userData.id,
      order_id: orderId,
      stripe_session_id: gatewayName === "Stripe" ? gatewayReference : undefined,
      paystack_reference: gatewayName === "PayStack" ? gatewayReference : undefined,
      reference: gatewayName === "PayStack" ? gatewayReference : undefined,
      flutterwave_transaction_id: gatewayName === "FlutterWave" ? gatewayTransactionId : undefined,
      transaction_id: gatewayName === "FlutterWave" ? gatewayTransactionId : undefined,
      tx_ref: gatewayName === "FlutterWave" ? gatewayReference : undefined,
      collection_id: gatewayName === "MercadoPago" ? mercadoPagoPaymentId : undefined,
      preference_id: gatewayName === "MercadoPago" ? gatewayReference : undefined,
      pidx: gatewayName === "Khalti" ? gatewayReference : undefined,
      payment_request_id: gatewayName === "Instamojo" ? gatewayReference : undefined,
      payment_id: gatewayName === "Instamojo" ? instamojoPaymentId : (gatewayName === "MercadoPago" ? mercadoPagoPaymentId : undefined),
      tap_charge_id: gatewayName === "Tap" ? tapChargeId || gatewayReference : undefined,
      charge_id: gatewayName === "Tap" ? tapChargeId || gatewayReference : undefined,
      paydunya_token: gatewayName === "PayDunya" ? paydunyaToken || gatewayReference : undefined,
      invoice_token: gatewayName === "PayDunya" ? paydunyaToken || gatewayReference : undefined,
      mollie_payment_id: gatewayName === "Mollie" ? molliePaymentId || gatewayReference : undefined,
      bkash_payment_id: gatewayName === "bKash" ? bkashPaymentId || gatewayReference : undefined,
      paymentID: gatewayName === "bKash" ? bkashPaymentId || gatewayReference : undefined,
      gateway_order_id: gatewayReference,
    })
      .then((res) => {
        if (res.data.Result === "true" && res.data.status === "granted") {
          showTost({ title: "Payment verified successfully." });
          localStorage.removeItem(storageKey);
          SectionCloseHandler();
          fetchUserData(latitude, longitude);
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          showTost({ title: res.data.ResponseMsg || `${gatewayName} payment verification pending.` });
        }
      })
      .catch(() => {
        showTost({ title: `Unable to verify ${gatewayName} payment.` });
      });
  }, [basUrl, fetchUserData, latitude, longitude, SectionCloseHandler]);

  const SendHandler = (Id) => {
    if (border) {
      setPayId(Id);
      setButton(true);
      const Data = {
        Planid: planLIst[id] && planLIst[id].id,
        Pname: Id,
        pMethodid: pId,
      };
      localStorage.setItem("Data", JSON.stringify(Data));
    } else {
      if (btnDis) {
        if ((planLIst[id]?.amt || 0) > coin) {
          showTost({ title: "Please Add Balance..!!" });
          setIsVisible(false);
        } else {
          setPayId(Id);
          setPlanId("PaymentDone");
        }
      } else {
        showTost({ title: "Please Select Payment Method" });
      }
    }
  };

  const PurchaseHandler = useCallback(() => {
    const userData = getRegisterUser();
    const Data = localStorage.getItem("Data");

    if (userData.id) {
      if (Data) {
        const Json = JSON.parse(Data);
        axios
          .post(`${basUrl}plan_purchase`, {
            uid: userData.id,
            plan_id: Json && Json.Planid,
            wall_amt: btnDis ? planLIst[id]?.amt || "0" : "0",
            transaction_id: Date.now(),
            pname: Json && Json.Pname,
            p_method_id: Json && Json.pMethodid,
          })
          .then((res) => {
            if (res.data.Result === "true") {
              showTost({ title: res.data.ResponseMsg });
              SectionCloseHandler();
              fetchUserData(latitude, longitude);
            }
        });
      }
    }
  }, [basUrl, btnDis, id, latitude, longitude, planLIst, SectionCloseHandler, fetchUserData]);

  useEffect(() => {
    loadData(latitude, longitude);
  }, [loadData, latitude, longitude]);

  useEffect(() => {
    if (legacyPaymentDoneProcessedRef.current) return;

    const Done = localStorage.getItem("PaymentDone");
    if (Done === "PaymentDoneUpgrade") {
      legacyPaymentDoneProcessedRef.current = true;
      PurchaseHandler();
      setTransactionId(Date.now());
      setAmount(localStorage.getItem("Amount"));
    }
  }, [PurchaseHandler, setAmount, setTransactionId]);

  useEffect(() => {
    if (hostedReturnProcessedRef.current) return;

    const params = new URLSearchParams(window.location.search);
    const gateway = params.get("payment_gateway") || params.get("gateway");
    const paymentStatus = params.get("payment_status");
    const hostedGateways = [
      "Stripe",
      "PayStack",
      "FlutterWave",
      "Payfast",
      "Midtrans",
      "2checkout",
      "2Checkout",
      "MercadoPago",
      "Khalti",
      "Khalti Payment",
      "Cashfree",
      "SSLCommerz",
      "Instamojo",
      "Tap",
      "PerfectMoney",
      "PayDunya",
      "Mollie",
      "bKash",
    ];

    if (!hostedGateways.includes(gateway)) return;

    hostedReturnProcessedRef.current = true;

    if (paymentStatus === "success") {
      const normalizedGateway =
        gateway === "2Checkout" ? "2checkout" : gateway === "Khalti Payment" ? "Khalti" : gateway;
      verifyHostedUpgradeReturn(params, normalizedGateway);
    } else if (paymentStatus === "cancelled") {
      showTost({ title: "Payment cancelled." });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [verifyHostedUpgradeReturn]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = String(position.coords.latitude);
          const long = String(position.coords.longitude);
          setLatitude(lat);
          setLongitude(long);
          fetchUserData(lat, long);
        },
        (err) => {
          console.warn("Geolocation query rejected or failed:", err);
        },
        { enableHighAccuracy: false, timeout: 5000 },
      );
    }
  }, [fetchUserData]);

  useEffect(() => {
    if (!planId) return;

    if (planId === "PaymentDone") {
      PurchaseHandler();
    } else if (planId === "PaymentVerified") {
      showTost({ title: "Payment verified successfully." });
      SectionCloseHandler();
      fetchUserData(latitude, longitude);
    } else {
      SectionCloseHandler();
    }
  }, [planId, PurchaseHandler, SectionCloseHandler, fetchUserData, latitude, longitude]);

  const GetStartedHandler = (index, id) => {
    if (String(currentPlanId) === String(id)) {
      showTost({ title: "This is your current plan" });
      return;
    }
    toggleBottomSheet("");
    setId(index);
    setPageName("Upgrade");
  };

  const SwitchHandler = () => {
    setBtnDis((prev) => !prev);
    setBorder("");
  };

  const renderPaymentGateways = () => {
    if (!button) return null;

    const amount = planLIst[id]?.amt;

    if (payId === "Razorpay")
      return <Razorpay Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
      if (payId === "FlutterWave")
        return <FlutterWave Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "SenangPay")
      return <SenangPay Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Payfast")
      return <Payfast Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Midtrans")
      return <Midtrans Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "2checkout")
      return <Checkout Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Khalti Payment")
      return <KhaltiPayment Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "MercadoPago")
      return <MercadoPagoCheckout Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Paytm")
      return <PaytmPayment Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Cashfree")
      return <Cashfree Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "SSLCommerz")
      return <SSLCommerz Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Instamojo")
      return <Instamojo Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Tap")
      return <Tap Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "PerfectMoney")
      return <PerfectMoney Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "PayDunya")
      return <PayDunya Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "Mollie")
      return <Mollie Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
    if (payId === "bKash")
      return <BKash Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;

    const modalChildren = (() => {
      if (payId === "Paypal")
        return <Paypal Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
      if (payId === "Stripe")
        return <StripePayment Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
      if (payId === "PayStack")
        return <PayStack Amount={amount} ItemType="plan" ItemId={planLIst[id]?.id} Attributes={attributes} />;
      return null;
    })();

    if (modalChildren) {
      return (
        <div
          onClick={() => setPayId("")}
          id="BlockSection"
          className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-[20%] max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]"
          >
            <div className="flex flex-col justify-center items-center text-center">
              {modalChildren}
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-[#e5e5e5] main-wrapper-history">
      <div className="content-body">
        <div className="container-fluid py-4 px-sm-4 px-3">
          <div className="row">
            <div className="col-xl-12">
              <div className="card card-rounded mb-4">
                <div className="card-body card-py-1">
                  <div className="person-header d-flex flex-wrap align-items-center justify-content-between gap-2">
                    <div>
                      <div className="fw-bold fs-24">{t("Choose Your Plan")}</div>
                      <div className="text-muted">
                        {currentPlanId !== "0"
                          ? `${t("Current subscription active")}${planData?.expire_date || planData?.plan_end_date ? ` until ${String(planData?.expire_date || planData?.plan_end_date).trim().replace(/[T ]00:00(:00)?(\.000)?$/i, '')}` : ""}`
                          : t("Unlock premium dating features when you are ready.")}
                      </div>
                    </div>
                    {currentPlanId !== "0" && (
                      <button
                        type="button"
                        onClick={PalanDetailsHandler}
                        className="btn text-white"
                        style={{ background: "rgba(152,14,255,255)" }}
                      >
                        {t("View Subscription")}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 mt-2">
              <div className="tab-content plan-content">
                <div className="tab-pane border-0 active show">
                  <div className="row justify-content-center">
                    {planLIst?.map((item, index) => {
                      const isCurrent = String(currentPlanId) === String(item.id);
                      const isPopular = String(item.is_popular || "0") === "1";
                      const featureGroups = groupedPlanFeatures(allPlanFeatures(planLIst));
                      const palette = planPalette(item);
                      const activeUntil = cleanDateStr(planData?.expire_date || planData?.plan_end_date);
                      return (
                      <div
                        key={index}
                        className="col-xxl-3 col-lg-6 col-md-6 col-sm-12 mb-4"
                      >
                        <div
                          className={`card card-rounded-1 h-100 position-relative overflow-hidden ${isCurrent && "ActivePlan"}`}
                          style={{
                            border: isCurrent || isPopular ? `2px solid ${palette.accent}` : "1px solid #eee",
                            boxShadow: `0 18px 36px ${hexToRgba(palette.accent, 0.16)}`,
                          }}
                        >
                          {isPopular && (
                            <div
                              className="position-absolute text-white fw-bold px-3 py-1"
                              style={{
                                top: 12,
                                left: 12,
                                borderRadius: 999,
                                background: palette.accent,
                                fontSize: 12,
                                zIndex: 2,
                              }}
                            >
                              {t("Popular")}
                            </div>
                          )}
                          <div className="card-body p-0">
                            <div className="p-sm-4 p-4">
                              <div
                                className="rounded-[18px] p-4 mb-3 position-relative overflow-hidden"
                                style={{
                                  background: `linear-gradient(135deg, ${palette.start}, ${palette.end})`,
                                  color: palette.text,
                                  minHeight: 188,
                                  boxShadow: `0 18px 34px ${hexToRgba(palette.accent, 0.2)}`,
                                }}
                              >
                                <div
                                  className="position-absolute"
                                  style={{
                                    width: 120,
                                    height: 120,
                                    right: -38,
                                    top: -38,
                                    borderRadius: "50%",
                                    background: "rgba(255,255,255,0.14)",
                                  }}
                                />
                                <div className="d-flex align-items-center justify-content-between gap-2 mb-4 position-relative">
                                  <div className="d-flex align-items-center gap-2">
                                    <div
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        width: 42,
                                        height: 42,
                                        borderRadius: "50%",
                                        background: "rgba(255,255,255,0.92)",
                                      }}
                                    >
                                      <span
                                        aria-hidden="true"
                                        style={{
                                          width: 22,
                                          height: 22,
                                          display: "inline-block",
                                          background: palette.accent,
                                          WebkitMask: `url(${heartIcon}) center / contain no-repeat`,
                                          mask: `url(${heartIcon}) center / contain no-repeat`,
                                        }}
                                      />
                                    </div>
                                    <h3 className="mb-0 text-uppercase fw-bold" style={{ fontSize: 22 }}>
                                      {item.title}
                                    </h3>
                                  </div>
                                  {item.savings_label && (
                                    <span
                                      className="fw-bold px-2 py-1"
                                      style={{
                                        background: "rgba(255,255,255,0.92)",
                                        color: palette.accent,
                                        borderRadius: 999,
                                        fontSize: 12,
                                      }}
                                    >
                                      {item.savings_label}
                                    </span>
                                  )}
                                </div>
                                <h2 className="mb-0 fw-bold" style={{ fontSize: 34 }}>
                                  {currency ? currency : "$"}
                                  {item.amt}
                                </h2>
                                <p className="fw-semi-bold mb-0 opacity-75">
                                  {t("Per")} {billingPeriodLabel(item)}
                                </p>
                                {isCurrent && activeUntil && (
                                  <p className="fw-semibold mb-0 mt-2" style={{ fontSize: 13, opacity: 0.82 }}>
                                    {t("Active until")} {activeUntil}
                                  </p>
                                )}
                              </div>
                              <p className="text-muted mb-3" style={{ minHeight: 22 }}>
                                {item.billing_note || `${item.day_limit} ${t("Days")} access`}
                              </p>
                              <button
                                onClick={() =>
                                  GetStartedHandler(index, item.id)
                                }
                                disabled={isCurrent}
                                style={{
                                  background: isCurrent ? "#e5e7eb" : palette.accent,
                                  color: isCurrent ? "#111827" : "#fff",
                                }}
                                className="btn w-100 fw-bold my-2"
                              >
                                {isCurrent ? t("Current Plan") : t("Get Started")}
                              </button>
                              <div className="text-center mt-2">
                                <button
                                  type="button"
                                  onClick={() => openPlanInfo(item)}
                                  className="border-0 bg-transparent p-0 fw-semibold"
                                  style={{
                                    color: palette.accent,
                                    fontSize: 13,
                                    textDecoration: "underline",
                                    textUnderlineOffset: 3,
                                  }}
                                >
                                  {t("View plan details")}
                                </button>
                              </div>
                              <div className="mt-4">
                                {Object.entries(featureGroups).map(([title, groupFeatures]) => (
                                  <div
                                    className="position-relative mb-4 rounded-[16px]"
                                    style={{
                                      border: "1px solid #ececf2",
                                      padding: "26px 18px 10px",
                                    }}
                                    key={title}
                                  >
                                    <div
                                      className="position-absolute fw-bold px-3 py-1 bg-white"
                                      style={{
                                        top: -15,
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        border: "1px solid #ececf2",
                                        borderRadius: 999,
                                        fontSize: 13,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {t(title)}
                                    </div>
                                    <ul className="list-unstyled p-0 m-0">
                                      {groupFeatures.map((feature) => {
                                        const included = planIncludesFeature(item, feature.label);
                                        return (
                                          <li
                                            className="py-[8px] d-flex align-items-start gap-3"
                                            key={feature.label}
                                            style={{
                                              color: included ? "#111827" : "#9ca3af",
                                              fontWeight: included ? 700 : 600,
                                            }}
                                          >
                                            <span
                                              aria-hidden="true"
                                              style={{
                                                minWidth: 20,
                                                height: 20,
                                                display: "inline-block",
                                                marginTop: 2,
                                                background: included ? "#111827" : "#9ca3af",
                                                WebkitMask: `url(${included ? checkIcon : lockIcon}) center / contain no-repeat`,
                                                mask: `url(${included ? checkIcon : lockIcon}) center / contain no-repeat`,
                                              }}
                                            />
                                            <span>{feature.label}</span>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                ))}
                              </div>
                              {item.renewal_note && (
                                <p className="text-muted mb-0 mt-3" style={{ fontSize: 13 }}>
                                  {item.renewal_note}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isVisible && (
        <div
          onClick={() => toggleBottomSheet("PayMent")}
          className="bottom-sheet2 w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bottom-sheet-content2"
          >
            <div className="mt-[10px]">
              {coin > 0 && (
                <div className="flex items-center justify-between">
                  <div className="mt-[5px] mb-[10px] flex gap-[10px] items-center">
                    <img src={wallet} alt="" />
                    <h6 className="m-0">
                      {t("My Wallet")} ($
                      {btnDis ? coin - (planLIst[id]?.amt || 0) : coin})
                    </h6>
                  </div>
                  <button>
                    <div className="df-center gap-3">
                      <label className="switch">
                        <input
                          onClick={SwitchHandler}
                          type="checkbox"
                          checked={btnDis}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </button>
                </div>
              )}
              <div className="scroll-container2 h-[330px]">
                {payDetails.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setBorder(item.title);
                      setPId(item.id);
                      setAttributes(item.attributes);
                    }}
                    className={`${border === item.title ? "border-[rgba(152,14,255,255)] bg-purple-50/20" : "border-gray-300"} mb-[10px] flex items-center justify-between gap-3 cursor-pointer border-[2px] rounded-[10px] px-[12px] py-[12px] transition-all`}
                  >
                    <div className="flex items-center gap-[12px] min-w-0 flex-1">
                      <img
                        src={imageBaseURL + item.img}
                        className="border-[2px] w-[50px] h-[50px] rounded-[10px] bg-gray-200 object-contain shrink-0"
                        alt=""
                      />
                      <div className="min-w-0 flex-1">
                        <h4 className="m-0 text-[16px] font-[700] text-gray-900 truncate">{item.title}</h4>
                        <p className="font-[500] text-[13px] leading-[18px] text-gray-500 m-0 mt-0.5">
                          {item.subtitle}
                        </p>
                      </div>
                    </div>
                    <div className="shrink-0 flex items-center justify-end pl-2">
                      <input
                        type="radio"
                        id={`radio-${index}`}
                        name="group1"
                        className="peer hidden"
                        checked={border === item.title}
                        readOnly
                      />
                      <div
                        className={`w-5 h-5 border-[2px] rounded-full ${border === item.title ? "border-[rgba(152,14,255,255)]" : "border-gray-300"} flex items-center justify-center`}
                      >
                        <span
                          className={`w-[10px] h-[10px] rounded-full ${border === item.title ? "bg-[rgba(152,14,255,255)]" : ""} duration-[0.3s]`}
                        ></span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button
              onClick={() => SendHandler(border)}
              className="text-white bg-[rgba(152,14,255,255)] w-[100%] font-[600] rounded-[10px] py-[10px] mt-[10px]"
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}

      {renderPaymentGateways()}

      {selectedPlanInfo && (
        <div
          onClick={closePlanInfo}
          className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-[32%] max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[55%] max-_1500_:w-[42%] bg-white rounded-[18px] p-[20px]"
            style={{ maxHeight: "86vh", overflowY: "auto" }}
          >
            <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <h4 className="m-0 fw-bold">{selectedPlanInfo.title}</h4>
                <p className="m-0 text-muted">
                  {currency ? currency : "$"}
                  {selectedPlanInfo.amt} {t("Per")} {billingPeriodLabel(selectedPlanInfo)}
                </p>
              </div>
              <button
                type="button"
                onClick={closePlanInfo}
                className="border-0 bg-light d-flex align-items-center justify-content-center"
                style={{ width: 36, height: 36, borderRadius: "50%", fontSize: 22 }}
                aria-label={t("Close")}
              >
                x
              </button>
            </div>

            {String(selectedPlanInfo.description || "").trim() && (
              <div className="mb-4">
                <h6 className="fw-bold mb-2">{t("Plan Description")}</h6>
                <p className="text-muted mb-0" style={{ whiteSpace: "pre-line" }}>
                  {String(selectedPlanInfo.description || "").trim()}
                </p>
              </div>
            )}

            {planFeatureItems(selectedPlanInfo).length > 0 && (
              <div className="mb-4">
                <h6 className="fw-bold mb-2">{t("Plan Features")}</h6>
                <div className="d-flex flex-column gap-2">
                  {planFeatureItems(selectedPlanInfo).map((feature) => (
                    <div
                      key={`${feature.group}-${feature.label}`}
                      className="d-flex align-items-start gap-2"
                    >
                      <span
                        aria-hidden="true"
                        style={{
                          minWidth: 18,
                          height: 18,
                          marginTop: 2,
                          display: "inline-block",
                          background: "rgba(152,14,255,255)",
                          WebkitMask: `url(${checkIcon}) center / contain no-repeat`,
                          mask: `url(${checkIcon}) center / contain no-repeat`,
                        }}
                      />
                      <div>
                        <div className="fw-bold">{feature.label}</div>
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          {t(feature.group)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {(String(selectedPlanInfo.billing_note || "").trim() ||
              String(selectedPlanInfo.renewal_note || "").trim()) && (
              <div className="rounded-[14px] p-3" style={{ background: "#faf7ff" }}>
                {String(selectedPlanInfo.billing_note || "").trim() && (
                  <div className="mb-3">
                    <h6 className="fw-bold mb-1">{t("Billing Copy")}</h6>
                    <p className="text-muted mb-0">
                      {String(selectedPlanInfo.billing_note || "").trim()}
                    </p>
                  </div>
                )}
                {String(selectedPlanInfo.renewal_note || "").trim() && (
                  <div>
                    <h6 className="fw-bold mb-1">{t("Renewal / Cancellation Note")}</h6>
                    <p className="text-muted mb-0">
                      {String(selectedPlanInfo.renewal_note || "").trim()}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {isVisible2 && (
        <div
          onClick={PalanDetailsHandler}
          className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-[20%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[45%] max-_1500_:w-[35%] bg-white rounded-[15px] px-[15px] py-[10px]"
          >
            <div className="flex items-center justify-between py-[5px]">
              <h6 className="m-0">{t("Payment method")}</h6>
              <h6 className="m-0">{planData?.p_name}</h6>
            </div>
            <div className="flex items-center justify-between py-[5px]">
              <h6 className="m-0">{t("Transaction id")}</h6>
              <h6 className="m-0">{planData?.trans_id}</h6>
            </div>
            <div className="flex items-center justify-between py-[5px] border-t-[2px]">
              <h6 className="m-0">{t("Date of Purchase")}</h6>
              <h6 className="m-0">{cleanDateStr(planData?.plan_start_date)}</h6>
            </div>
            <div className="flex items-center justify-between py-[5px] border-b-[2px]">
              <h6 className="m-0">{t("Date of Expiry")}</h6>
              <h6 className="m-0">{cleanDateStr(planData?.plan_end_date)}</h6>
            </div>
            <div className="flex items-center justify-between py-[5px]">
              <h6 className="m-0">{t("Membership Amount")}</h6>
              <h6 className="m-0">
                {currency ? currency : "$"}
                {planData?.amount}
              </h6>
            </div>
          </div>
        </div>
      )}

      <div onClick={PalanDetailsHandler} id="overlay" className="overlay"></div>

      {loading && (
        <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
          <LodingLottie
            ClassCss={
              "w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"
            }
          />
        </div>
      )}
    </div>
  );
};

export default Upgrade;
/* jshint ignore:end */
